<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="orders" :active="'orders'"></v-left>
    <div>


      <div class="relative">
        <el-tabs v-model="filter.order_status" @tab-click="handleClickTab" :disabled="loading_table" v-if="statics_orders" type="card" size="large">
          <el-tab-pane :label="count.label + '(' + count.count  + ')' " :name="count.status" v-for="(count, c_index) in statics_orders" :key="c_index"></el-tab-pane>
        </el-tabs>
        <div class="warning-btns-dd2" style="margin-bottom: 10px;">
          <el-button size="small" style="margin-left:5px;" @click="click_exception(0)">清除</el-button>
          <el-button size="small" :type="filter.has_seller_remark == 1 ? 'default' : 'danger' " style="margin-left:5px;" @click="click_has_seller_remark" :class="[filter.has_seller_remark == 1 ? 'el-icon-watch' : 'el-icon-watch']"> 有备注</el-button>
          <el-button size="small" :type="filter.notice_flag_status == 1 ? 'default' : 'danger' " style="margin-left:5px;" @click="click_notice_flag" :class="[filter.notice_flag_status == 1 ? 'el-icon-star-on' : 'el-icon-star-off']"> 特别关注</el-button>
          <el-button  
            :type="filter.exception_status == count.status ? 'default' : 'danger'" 
            v-for="(count, c_index) in exception_orders" 
            :key="c_index" 
            size="small"
            style="margin-left:5px;" 
            @click="click_exception(count.status)">{{count.label + '(' + count.count  + ')'}}</el-button>
        </div>
      </div>

      <div class="filter-dic clearfix" style="margin-bottom:10px;">
        <div class="fl">
          <el-date-picker
            size="small"
            style="width: 366px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-select v-model="filter.country_code" placeholder="国家" size="small" clearable @change="change_country_filter">
              <el-option v-for="item in country_options" :key="item.country_code" :label="item.name_en + '/' + item.name_cn + ' (' + item.count + ')'" :value="item.country_code"></el-option>
          </el-select>  
          <el-select v-model="filter.app_id" placeholder="店铺" size="small" clearable @change="change_app_filter" style="width:133px;">
            <el-option v-for="item in $store.state.public.cfg.apps_options" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>  
          <el-select v-model="filter.approved_member_id" placeholder="审核人" size="small" clearable style="width:133px;" v-if="uid === 1">
            <el-option v-for="item in member_options" :key="item.member_id" :label="item.member_name" :value="item.member_id"></el-option>
          </el-select>  
          <el-select v-model="filter.order_type2" placeholder="订单类型" size="small" clearable style="width:133px;">
            <el-option v-for="item in order_type2_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="filter.package_status" placeholder="包裹状态" size="small" clearable style="width:133px;">
            <el-option v-for="item in $store.state.public.cfg.package_status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="filter.phone_case_style_id" placeholder="颜色款式" size="small" clearable style="width:166px;" filterable>
            <el-option v-for="item in phone_case_style_options" :key="item.value" :label="item.label_cn" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="filter.diy_model_id" placeholder="型号" filterable size="small" clearable style="width:166px;">
            <el-option v-for="item in phone_model_options" :key="item.id" :label="item.model_name" :value="item.id"></el-option>
          </el-select>
          <el-input placeholder="请输入内容" clearable v-model="filter.keyword" class="input-with-select" style="width:499px;" size="small">
            <el-select v-model="filter.keyword_type" slot="prepend" placeholder="请选择" style="width:122px">
              <el-option label="智能识别" value="auto"></el-option>
              <el-option label="平台编号" value="platform_order_number"></el-option>
              <el-option label="订单号" value="order_no"></el-option>
              <el-option label="物流单号" value="logistics_track_number"></el-option>
              <el-option label="工厂单号" value="factory_order_no"></el-option>
              <el-option label="邮箱" value="email"></el-option>
              <el-option label="手机号" value="mobile"></el-option>
              <el-option label="备注" value="remark"></el-option>
              <el-option label="YOURNAME" value="your_name"></el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>

          <el-button size="small" style="margin-left: 0px;" @click="pullShopifyOrders" v-if="uid === 1">Sync</el-button>
          <el-button size="small" style="margin-left: 0px;" @click="pullShopifyOrders_force" v-if="uid === 1">Sync Force</el-button>
          <!-- <el-button size="small" style="margin-left: 0px;" @click="redirect('/orders/order-create')">订单图库</el-button> -->
          <!-- <el-button size="small" style="margin-left: 0px;" @click="redirect('/orders/diy-create')">作品浏览</el-button> -->
          <el-button size="small" v-if="filter.order_status == '2'" style="margin-left: 0px;" @click="run_draw">本页NAME生图</el-button>
          <el-button size="small" v-if="filter.order_status == '2'" style="margin-left: 0px;" @click="approve_page">本页NAME审核</el-button>
          <el-button size="small" v-if="filter.order_status == '10'" style="margin-left: 0px;" @click="toCreateFactoryOrder">推手机壳到工厂</el-button>
          <el-button size="small" v-if="filter.order_status == '20'" style="margin-left: 0px;" @click="toDownloadZip">手机壳.ZIP</el-button>
          <el-button size="small" v-if="filter.order_status == '20'" style="margin-left: 0px;" @click="toDownloadZip2_necklace">饰品.xlsx</el-button>
          <el-button size="small" v-if="filter.order_status == '20'" style="margin-left: 0px;" @click="to_apply_Produce2">申请厂2面单</el-button>
          <el-button size="small" v-if="filter.order_status == '20'" style="margin-left: 0px;" @click="redirect('/logistics-label', true)">去拣货</el-button>
          <el-button size="small" v-if="filter.order_status == '31'" style="margin-left: 0px;" @click="to_print_labels">打印面单</el-button>
          <el-button size="small" v-if="filter.order_status == '10'" style="margin-left: 0px;" @click="redirect('/factory?tab=orders', true)">查看工厂订单</el-button>
        </div>
      </div>
      <div>

        <el-table
          :data="list_data.list"
          v-loading="loading_table"
          style="width: 100%"
          ref="multipleTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
          border
        >
          <el-table-column type="selection" width="44" :key="Math.random()"> </el-table-column>
          <el-table-column prop="order_no" label="Order" width="222" :key="Math.random()">
            <template slot-scope="scope">
              <div class="relative">
                <div style="margin-bottom: 5px;">
                  <el-tag type="info" size="small" style="padding-left:0;">{{scope.row.shop_name}}</el-tag>
                  <el-tag type="danger" size="small">{{scope.row.order_status_show}}</el-tag>
                </div>
                <div class="pointer">{{ scope.row.order_no }}</div>
                <div>
                  <a>#{{scope.row.ebay_order_name ? scope.row.ebay_order_name : scope.row.ebay_order_number}}</a> 
                </div>
                <div style="margin-top:5px;padding-top:5px;border-top:1px dashed #ddd;" v-if="uid === 1">
                  <p>Total：{{ scope.row.currency }} {{ scope.row.amount_total }} <b style="margin-left:10px;">{{scope.row.address_info.country_code}}</b></p>
                </div>
                <div v-if="scope.row.address_info">
                  <p style="border:1px solid #ddd;">{{scope.row.address_info.phone}}</p>
                  <p style="border:1px solid #ddd;">{{scope.row.address_info.email}}</p>
                  <p style="border:1px solid #ddd;font-weight:bold;color:#000;font-size:16px;">{{ scope.row.address_info ? scope.row.address_info.first_name + " " + scope.row.address_info.last_name : '' }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="order_no" label="Product" min-width="1000" :key="Math.random()">
            <template slot-scope="scope">
              <el-table
                :data=" scope.row.detail "
                style="width: 100%"
              >
                <el-table-column prop="sku" label="SKU" width="256" class-name="sku-first-1">
                  <template slot-scope="scope2">
                    <div v-if="scope.row.is_phone_case == 1">
                      <div style="color:#cccccc;">
                        <div>
                          <span>{{ scope2.row.sku_code }}</span>
                          <b style="margin-left:5px;color:black;font-size:14px;" v-if="scope2.row.quantity <= 1"> x {{ scope2.row.quantity }}</b>
                          <b style="margin-left:5px;color:red;font-size:20px;" v-else> x {{ scope2.row.quantity }}</b>
                        </div>
                        <div v-if="scope2.row.model_info">{{ scope2.row.model_info.model_name }}</div>

                        <div>
                          <ul v-if="scope2.row.spec_properties && scope2.row.spec_properties.size > 0" style="border:1px dashed gray;padding:5px;box-sizing: border-box;">
                            <section v-for="(pr, index_pr) in scope2.row.spec_properties" :key="index_pr">
                              <li v-if="!(pr.value && pr.value.indexOf('https://')!==-1)">
                                <span>{{ pr.name }}: </span>
                                <span>{{ pr.value }}</span>
                                <span v-if="index_pr == 0 " style="margin-left:5px;">
                                  <b v-if="scope2.row.quantity > 1" style="font-size: 18px;color: red;">x {{ scope2.row.quantity }}</b>
                                  <b v-else style="font-weight: bold;color: black;">x {{ scope2.row.quantity }}</b>
                                </span>
                              </li>
                            </section>
                          </ul>
                          <div v-if="scope2.row.font_info">
                            <span>Font: </span>
                            <span>{{ scope2.row.font_info.font_label }}</span>
                          </div>
                          <div v-if="scope2.row.customize_form && scope2.row.customize_form.hasOwnProperty('your_name') && scope2.row.hasOwnProperty('font_info') && scope2.row.font_info">
                            <span style="margin-right: 10px;">Your Name:</span>
                            <span :style="{
                              'font-family':scope2.row.font_info ? scope2.row.font_info.font_name : 'default', 
                              'font-size':(18*(scope2.row.font_info.hasOwnProperty('font_scan') && scope2.row.font_info.font_scan ? scope2.row.font_info.font_scan : 1)) + 'px', 
                              color:'black'
                              }">{{ scope2.row.customize_form.your_name }}</span>
                          </div>
                        </div>

                      </div>
                      <div style="margin-top:10px;">
                        <div 
                          v-for="(spec, index_spec) in scope2.row.produce_specs" 
                          :key="index_spec" 
                          style="box-shadow:1px 1px 3px gray;border: 1px solid #dfdfdf;padding:5px;box-sizing:border-box;margin-top:10px;position:relative;">
                          <div v-if="scope2.row.diy_model_id > 0">
                            <el-select
                            ref="mySelect_phone_model" 
                              size="small"
                              v-model="spec.produce_model_id"
                              filterable
                              @change="check_spec_option(spec)"
                            >
                              <el-option
                                v-for="item in systerm_model_options"
                                :key="item.id"
                                :label="item.model_name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </div>
                          <!-- <el-select
                            ref="mySelect_sku" 
                            size="small"
                            v-model="spec.sku_id"
                            filterable
                            @change="check_spec_option(spec)"
                          >
                            <el-option
                              v-for="sku in system_sku_options"
                              :key="sku.id"
                              :label="sku.sku_code + ' / ' + sku.title"
                              :value="sku.id"
                            ></el-option>
                          </el-select> -->
                          <el-select
                            ref="mySelect_style" 
                            size="small"
                            v-model="spec.factory_phone_case_style_id"
                            filterable
                            clearable
                            @change="change_factory_phone_case_style(spec)"
                          >
                            <el-option
                              v-for="st in phone_case_style_options"
                              :key="st.value"
                              :label="st.label_cn"
                              :value="st.value"
                            ></el-option>
                          </el-select>
                          <i class="el-icon-circle-close" style="position: absolute;top:-10px;right:-10px;z-index:2;font-size:20px;cursor:pointer;" @click="del_my_spec(scope2.row, index_spec)"></i>
                        </div>
                        <i class="el-icon-plus" style="font-size:20px;color:gray;cursor:pointer;margin-top:10px;" @click="add_my_spec_line(scope2.row)"></i>
                      </div>
                    </div>
                    <div v-else>
                      <div style=" white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ scope2.row.goods_title }}</div>
                      <div style="font-size: 12px;color: gray;position:relative">
                        <ul v-if="scope2.row.spec_properties" style="border:1px dashed gray;padding:5px;box-sizing: border-box;">
                          <section v-for="(pr, index_pr) in scope2.row.spec_properties" :key="index_pr">
                            <li v-if="!(pr.value && pr.value.indexOf('https://')!==-1)">
                              <span>{{ pr.name }}: </span>
                              <span>{{ pr.value }}</span>
                              <span v-if="index_pr == 0 " style="margin-left:5px;">
                                <b v-if="scope2.row.quantity > 1" style="font-size: 18px;color: red;">x {{ scope2.row.quantity }}</b>
                                <b v-else style="font-weight: bold;color: black;">x {{ scope2.row.quantity }}</b>
                              </span>
                            </li>
                          </section>
                        </ul>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="image" label="IMAGE" width="133">
                  <template slot-scope="scope2">
                    <div style="text-align:center;">
                      <div>
                        <el-image
                          style="width: 55px"
                          v-if="scope2.row.image"
                          :src="scope2.row.image"
                          :preview-src-list="[scope2.row.image]"
                        >
                        </el-image>
                        <el-image
                        style="width: 44px"
                        v-if="scope2.row.ebay_image"
                        :src="scope2.row.ebay_image"
                        :preview-src-list="[scope2.row.ebay_image]"
                      >
                      </el-image>
                      </div>
                      <div>{{scope2.row.design_type_label}}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="file_list" label="FILE" min-width="100">
                  <template slot-scope="scope2">
                    <el-image
                      v-if="uid === 1 || scope2.row.is_close_upload_files == 0"
                      style="width: 44px"
                      v-for="(src_ff, index_ff) in scope2.row.upload_file_list_images"
                      :key="index_ff"
                      :src="src_ff"
                      :preview-src-list="scope2.row.upload_file_list_images"
                    >
                    </el-image>
                    <div v-if="scope2.row.design_type == 1 && (scope2.row.input1 || scope2.row.input2)">
                      <div v-if="scope2.row.input1">{{scope2.row.input1}}</div>
                      <div v-if="scope2.row.input2">{{scope2.row.input2}}</div>
                    </div>
                    <div>
                      <el-tag size="mini" class="pointer" @click="to_pop_upload_files(scope.row)" v-if="uid === 1 || scope2.row.is_close_upload_files == 0">more</el-tag>
                      <section v-if="uid === 1">
                        <el-tag type="warning" size="mini" class="pointer" @click="to_remove_upload_files(scope2.row, 1)" v-if="scope2.row.is_close_upload_files == 0">remove</el-tag>
                        <el-tag type="warning" size="mini" class="pointer" @click="to_remove_upload_files(scope2.row, 0)" v-else>show</el-tag>
                      </section>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="auto_design" label="COS" width="122">
                  <template slot-scope="scope2">
                    <section v-if="scope2.row.auto_design">
                      <div v-if="scope2.row.auto_design.hasOwnProperty('preview_image_oss') && scope2.row.auto_design.preview_image_oss" style="position:relative;width:88px;min-height:88px;">
                        <el-image
                          style="width: 86px;position:absolute;left:0;top:0;"
                          :src="scope2.row.auto_design.preview_image_oss"
                          :preview-src-list="[scope2.row.auto_design.preview_image_oss, scope2.row.auto_design.image_draw]"
                        >
                        </el-image>
                      </div>
                      <div v-else-if="scope2.row.auto_design.hasOwnProperty('image_draw') && scope2.row.auto_design.image_draw" style="position:relative;width:88px;min-height:88px;">
                        <el-image
                          style="width: 40px;height:80px;position:absolute;left:0;top:0;"
                          :src="scope2.row.auto_design.image_draw"
                          :preview-src-list="[scope2.row.auto_design.image_draw]"
                        >
                        </el-image>
                        <el-image
                          style="width: 40px;height:80px;position:absolute;left:0;top:0;"
                          v-if="scope2.row.sku_info.hasOwnProperty('camera_image')"
                          :src="scope2.row.sku_info.camera_image"
                          :preview-src-list="[scope2.row.auto_design.image_draw]"
                        >
                        </el-image>
                      </div>
                      <div>
                        <div v-if="scope2.row.input1">{{scope2.row.input1}}</div>
                        <div v-if="scope2.row.input2">{{scope2.row.input2}}</div>
                      </div>
                    </section>
                  </template>
                </el-table-column>
                <el-table-column prop="image_diy" label="DIY" width="111">
                  <template slot-scope="scope2">
                    <section v-if="scope2.row.diy_info && scope2.row.diy_info.hasOwnProperty('preview_image_oss') && scope2.row.diy_info.preview_image_oss">
                      <el-image
                        style="width: 88px"
                        v-if="scope2.row.diy_info.preview_image_oss"
                        :src="scope2.row.diy_info.preview_image_oss"
                        :preview-src-list="[scope2.row.diy_info.preview_image_oss, scope2.row.diy_info.image_draw]"
                      >
                      </el-image> 
                    </section>
                    <section v-else>
                      <el-image
                        style="width: 44px"
                        v-if="scope2.row.image_diy"
                        :src="scope2.row.image_diy"
                        :preview-src-list="[scope2.row.image_diy_draw]"
                      >
                      </el-image>
                      <el-image
                        style="width: 44px"
                        v-else-if="scope2.row.hasOwnProperty('diy_info') && scope2.row.diy_info"
                        :src="scope2.row.diy_info.image_diy"
                        :preview-src-list="[scope2.row.diy_info.image_draw]"
                      >
                      </el-image>
                    </section>
                  </template>
                </el-table-column>
                <el-table-column prop="produce_image_ori" label="PROD-ORI" min-width="166">
                  <template slot-scope="scope2">
                    <div class="clearfix">
                      <div class="fl">
                        <ul class="clearfix">
                          <li v-for="(im_pro, index_pro) in scope2.row.produce_images" :key="index_pro" class="fl" style="width:155px;">
                            <el-image
                              style="width: 80px;"
                              :src="im_pro.file_oss_ali"
                              :preview-src-list="[im_pro.file_oss_ali]"
                            >
                            </el-image>
                            <div><el-tag style="cursor:pointer;"  @click="remove_produce_images(scope2.row, index_pro)">Delete</el-tag></div>
                            <div style="margin-top:5px;" v-if="im_pro.hasOwnProperty('file_oss_ali_clear') && im_pro.file_oss_ali_clear" >
                              <el-tag style="cursor:pointer;" type="info" @click="remove_produce_image_clear(scope2.row, im_pro.file_oss_ali_clear)">Del Face</el-tag>
                            </div>
                            <div style="margin-top:5px;" v-else>
                              <el-tag style="cursor:pointer;" @click="do_produce_image_clear(scope2.row, im_pro.file_oss_ali)">Face</el-tag>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div class="fl m-l-10">
                        <el-upload
                          class="avatar-uploader"
                          :action="'/order-api/v1/pub/helpers/upload-to-ali-oss?token=' + token"
                          :on-success="(response, file, fileList) => {
                              return upload_produce_images_success(
                                response,
                                file,
                                fileList,
                                scope2.row
                              );
                            }
                          "
                          :show-file-list="false"
                        >
                          <i class="el-icon-plus avatar-uploader-icon" style="width: 64px; height: 64px; line-height: 64px"></i>
                        </el-upload>
                      </div>
                      <div class="fr" v-if="scope2.row.diy_model_id > 0">
                        <el-tag size="small" style="color:rgb(231, 50, 150);background:#fff;" class="pointer" @click="change_produce_image_font_color(scope2.row, '231, 50, 150')">Pink</el-tag><br>
                        <el-tag size="small" style="color:black;background:#fff;" class="pointer" @click="change_produce_image_font_color(scope2.row, '0,0,0')">Black</el-tag><br>
                        <el-tag size="small" style="color:white;background:black;" class="pointer" @click="change_produce_image_font_color(scope2.row, '255,255,255')">White</el-tag><br>
                        <el-tag size="small" type="success" class="pointer" @click="to_chat(scope2.row)">Chat</el-tag><br>
                        <el-tag size="small" type="primary" class="pointer" @click="to_diy(scope.row, scope2.row, 1)">Design</el-tag><br>
                        <!-- <el-tag size="small" type="primary" class="pointer" @click="to_diy(scope.row, scope2.row, 2)">Design2</el-tag> -->
                        <div v-if="scope2.row.produce_image_doing">
                          <i class="el-icon-loading" style="font-size: 32px;"></i>
                        </div>
                      </div>
                      <div class="fr" v-else>
                        <el-tag size="small" type="primary" class="pointer" @click="to_draw_produce_image(scope2.row)" v-loading="scope2.row.draw_loading">Draw</el-tag><br>
                        <el-tag size="small" type="success" class="pointer" @click="to_chat(scope2.row)" style="margin-top: 5px;">Chat</el-tag>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="Handle" width="122" align="center" :key="Math.random()">
            <template slot-scope="scope">
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="uid === 1" @click="to_pop_email(scope.row)">发送邮件</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="scope.row.enable_approve" @click="to_approve_order([scope.row.order_no])">审核订单</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="scope.row.enable_produce" @click="to_produce_order(scope.row)">标记生产</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="scope.row.enable_package" @click="to_create_package(scope.row)">申请面单</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="scope.row.enable_printf" @click="to_printf_order(scope.row)">打印面单</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="scope.row.enable_storage" @click="to_storage_order(scope.row)">搁置订单</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="scope.row.enable_pending" @click="to_pending_order(scope.row)">打回待审核</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="scope.row.enable_recreate_package" @click="to_create_package_2(scope.row)">补发包裹</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" @click="to_edit_address(scope.row)">编辑地址</el-button>
              <el-button size="small" class="pointer" style="margin-top:8px;margin-left:0;" v-if="uid === 1" @click="to_remove_order(scope.row)" :disabled="scope.row.remove_loading" v-loading="scope.row.remove_loading">删除订单</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="seller_remark" label="Remark" width="256" :key="Math.random()" >
            <template slot-scope="scope">
              <div class="relative">
                <el-input type="textarea" v-model="scope.row.seller_remark2" :rows="scope.row.remark_input_rows" @focus="scope.row.remark_input_rows = 10" @blur="blur_seller_remark(scope.row)"></el-input>
                <el-tag style="position:absolute;right:5px;bottom:10px;cursor: pointer;" v-if="scope.row.seller_remark2" @click="saveRemark(scope.row)">保存</el-tag>
              </div>
              <div v-if="scope.row.is_seller_remark_submit_loading">
                <i class="el-icon-loading" style="font-size: 32px;"></i>
              </div>
              <ul style="margin-top:10px;">
                <li v-for="(remark, index_r2) in (scope.row.is_seller_remark_slide_mod ? scope.row.remark_list_slide : scope.row.remark_list)" :key="index_r2" class="seller-remark-list-001">
                  <div v-html="remark.remark_content"></div>
                  <p class="gray-color members">{{ remark.remark_time }} {{ remark.member_name }}</p>
                </li>
              </ul>
              <div v-if="scope.row.remark_list.length > 2">
                <a class="pointer" @click="scope.row.is_seller_remark_slide_mod = false" v-if="scope.row.is_seller_remark_slide_mod">展开</a>
                <a class="pointer" @click="scope.row.is_seller_remark_slide_mod = true" v-else>收起</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="Time" width="444px">
            <template slot-scope="scope">
              <div style="font-size:28px;">
                <i :class="[ scope.row.notice_flag_status == 1 ? 'el-icon-star-on' : 'el-icon-star-off', 'pointer']" @click="notice_focus_click(scope.row)"></i>
              </div>
              <p>创建时间CRE：{{ scope.row.ctime }}</p>
              <p v-if="scope.row.payment_time">
                付款时间LOC：{{ scope.row.payment_time }}<br>
                付款时间UTC：{{ scope.row.payment_time_utc }}
              </p>
              <p v-if="scope.row.approved_time">
                审核时间：{{ scope.row.approved_time }} <span v-if="scope.row.approved_member_name">|<b>{{ scope.row.approved_member_name }}</b></span>
              </p>
              <div v-if="scope.row.produce_submit_time">
                提交工厂：{{ scope.row.produce_submit_time }} <a v-if="scope.row.factory_order_no_list">{{ scope.row.factory_order_no_list }}</a>
              </div>
              <section v-for="(pack, index_pack) in scope.row.package_list" :key="pack.id">
                <p v-if="pack.send_time">
                  发货时间{{index_pack+1}} {{ pack.send_time }}
                </p>
              </section>
              <p v-if="scope.row.cancel_time">
                取消时间：{{ scope.row.cancel_time }}
              </p>
              <p v-if="scope.row.factory_order_no_set_str">工厂单号：<a @click="redirect('/factory/orders?factory_order_no_arr=' + scope.row.factory_order_no_set_str)">{{scope.row.factory_order_no_set_str}}</a></p>
              <div v-for="(pack, index_pack2) in scope.row.package_list" :key="index_pack2" class="package-list-li">
                <p class="p2">
                  国际包裹{{index_pack2+1}}: <a style="cursor:pointer" @click="to_pop_track_info(pack.track_number)">{{pack.track_number}}</a>
                  <span style="color:gray;" v-if="pack.channel_code"> | {{pack.channel_code}}</span>
                  <span style="color:gray;" v-if="pack.channel_name"> | {{pack.channel_name}}</span>
                  <el-tag size="small" type="primary" style="cursor:pointer;" @click="print_one_label(pack)" v-if="pack.track_number">打印</el-tag>
                  <el-tag size="small" type="warning" style="cursor:pointer" @click="to_send_order(pack)" v-if="!pack.send_time && pack.track_number">发货</el-tag>
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="my-page"
          background
          :page-sizes="[10, 20, 50, 100, 200, 300, 400]"
          :current-page="list_data.page"
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          @size-change="handleSizeChange"
          :total="list_data.total"
        >
        </el-pagination>
      </div>
    </div>
    <component
      :is="popName"
      :orders="edit_row"
      :checked_orders="multipleSelection"
      :diy_info="pop_diy_info"
      :order_goods_row="edit_order_goods_row"
      :track_number="track_number"
      :is_package_2="is_package_2" 
      :is_produce_2="is_produce_2" 
      :design_version="design_version"
      :email_message_type="email_message_type"
    ></component>
    <insert_draw ref="drawRef" :sub="draw_sub"></insert_draw>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_drag = (resolve) => require(["@/pages/orders/_pop_drag"], resolve);
const pop_logistcs = (resolve) => require(["@/pages/logistics/_pop_edit"], resolve);
const pop_flag_produce = (resolve) => require(["@/pages/orders/_pop_flag_produce"], resolve);
const pop_create_package = (resolve) => require(["@/pages/logistics/_pop_create_package"], resolve);
const pop_edit_address = (resolve) => require(["@/pages/orders/_pop_edit_address"], resolve);
const pop_pro_image = (resolve) => require(["@/pages/orders/_pop_pro_image"], resolve);
const pop_produce_order = (resolve) => require(["@/pages/orders/_pop_produce_order"], resolve);
const pop_export_produce2 = (resolve) => require(["@/pages/orders/_pop_export_produce2"], resolve);
const pop_export_produce2_necklace = (resolve) => require(["@/pages/orders/_pop_export_produce2_necklace"], resolve);
const pop_track_info = (resolve) => require(["@/pages/logistics/_pop_track"], resolve);
const pop_email = (resolve) => require(["@/pages/email/_pop_compose"], resolve);
const pop_upload_files = (resolve) => require(["@/pages/orders/_pop_upload_files"], resolve);
const pop_diy = (resolve) => require(["@/pages/orders/designers/_pop_diy"], resolve);
const pop_print_labels = (resolve) => require(["@/pages/orders/_pop_print_labels"], resolve);
const pop_chat = (resolve) => require(["@/pages/orders/_pop_chat"], resolve);
const insert_draw = (resolve) => require(["@/pages/orders/_insert_draw"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_drag,
    pop_pro_image,
    pop_logistcs,
    pop_flag_produce,
    pop_create_package,
    pop_produce_order,
    pop_edit_address,
    pop_track_info,
    pop_export_produce2,
    pop_export_produce2_necklace,
    pop_email,
    pop_upload_files,
    pop_diy,
    pop_print_labels,
    pop_chat,
    insert_draw,
  },
  data() {
    return {
      uid:0,
      loading: false,
      popName: null,
      pop_diy_info: null,
      edit_row: null,
      edit_order_goods_row: null,
      draw_sub:null,
      multipleSelection: [],
      left_active: "",
      token: localStorage.getItem("token"),
      statics_orders: null,
      exception_orders: null,
      loading_table: false,
      track_number: null,
      is_package_2: false,
      is_produce_2: false,
      design_version:1,
      email_message_type:null,
      filter: {
        page: 1,
        size: 20,
        platform: "",
        app_id:"",
        platform_shop_id:"",
        keyword_type: "auto",
        keyword:"",
        order_status: "2",
        exception_status:"0",
        time_range: [],
        country_code:"",
        order_no: "",
        order_type2:"",
        package_status:"",
        shopify_order_number: "",
        notice_flag_status: '',
        has_seller_remark: "",
        approved_member_id:"",

        phone_case_style_id:"",
        diy_model_id:"",

      },
      list_data: {
        size: 20,
        page: 1,
        total: 0,
        list: [],
      },
      systerm_model_options: [],
      system_sku_options: [],
      phone_case_style_options:[],
      phone_model_options:[],
      member_options: [],
      order_type2_options: [
        {value:"phone_case", label:"手机壳"},
        {value:"not_phone_case", label:"非手机壳"},
      ],
      order_step_options: [
        { value: 1, label: "未付款" },
        { value: 2, label: "已付款" },
        { value: 3, label: "已生产" },
        { value: 4, label: "已发货" },
        { value: 5, label: "已售后" },
        { value: 6, label: "已完成" },
        { value: 7, label: "已取消" },
      ],
      app_options:[],
      country_options: [  
        { code: 'US', label: 'United States' },  
        { code: 'GB', label: 'United Kingdom' },  
        { code: 'AU', label: 'Australia' },  
        { code: 'FR', label: 'France' },  
        { code: 'DE', label: 'Germany' },  
        { code: 'CH', label: 'Switzerland' },  
        { code: 'DK', label: 'Denmark' },  
        { code: 'SE', label: 'Sweden' },  
        { code: 'NZ', label: 'New Zealand' },  
        { code: 'ES', label: 'Spain' },  
        { code: 'IE', label: 'Ireland' },  
        { code: 'NL', label: 'Netherlands' },  
        { code: 'IT', label: 'Italy' },  
        { code: 'FI', label: 'Finland' },  
        { code: 'PT', label: 'Portugal' },  
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.filter.size = val;
      this.filter.page = 1;
      this.getList();
    },
    toEditProImage(row) {
      this.edit_order_goods_row = row;
      this.popName = "pop_pro_image";
    },
    to_edit_address(row) {
      this.edit_row = row;
      this.popName = "pop_edit_address";
    },
    toFlagProduce(row) {
      this.edit_row = row;
      this.popName = "pop_flag_produce";
    },
    toSend(row) {
      this.edit_row = row;
      this.popName = "pop_logistcs";
    },
    toCreateFactoryOrder() {
      this.popName = "pop_produce_order";
    },
    toDownloadZip() { 
      this.popName = "pop_export_produce2";
    },
    toDownloadZip2_necklace() { 
      this.popName = "pop_export_produce2_necklace";
    },
    to_apply_Produce2() { 
      this.edit_row = null;
      this.is_package_2 = false;
      this.is_produce_2 = true;
      this.popName = "pop_create_package";
    },
    to_print_labels(row = null) { 
      this.edit_row = row;
      this.popName = "pop_print_labels";
    },
    to_pop_upload_files(row) { 
      this.edit_row = row;
      this.popName = "pop_upload_files";
    },
    to_diy(order, order_goods, version) { 
      this.design_version = version;
      this.edit_order_goods_row = order_goods;
      this.edit_row = order;
      this.popName = "pop_diy";
    },
    to_chat(row) { 
      this.edit_order_goods_row = row;
      this.popName = "pop_chat";
    },
    to_remove_upload_files(row, is_black){
      this.$confirm('删除原图', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.draw_loading = true;
        this.$http
          .post("/v1/pri/orders/black-upload-files", {
            orders_goods_id:row.id,
            is_black:is_black,
          })
          .then((response) => {
            row.draw_loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "绘画成功",
                type: "success",
              });
              this.reload_row(row.order_no)
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          }).catch((err) => {
            alert("绘画失败")
            row.draw_loading = false;
          })
      })
    },
    to_draw_produce_image(row){
      this.$confirm('创建生产图', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.draw_loading = true;
        this.$http
          .post("/v1/pri/factory-orders/draw-order-goods-produce-image", {
            orders_goods_id:row.id,
          })
          .then((response) => {
            row.draw_loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "绘画成功",
                type: "success",
              });
              this.reload_row(row.order_no)
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          }).catch((err) => {
            alert("绘画失败")
            row.draw_loading = false;
          })
      })
    },
    to_remove_order(row){
      this.$confirm('删除订单', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.remove_loading = true;
        this.$http
          .post("/v1/pri/orders/remove", {
            ids:[row.id]
          })
          .then((response) => {
            row.remove_loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
      })
    },
    changePage(e) {
      this.list_data.list = [];
      this.list_data.total = 0;
      this.filter.page = e;
      this.getList();
    },
    search() {
      if (this.filter.keyword && this.filter.keyword_type != 'factory_order_no') { 
        this.filter.order_status = "0";
      }
      this.filter.page = 1;
      this.getList();
    },
    toPopProduce(row) {
      this.popName = "pop_produce";
      this.edit_row = row;
    },
    toPopDrag(sub) {
      if (sub.diy_info) {
        this.popName = "pop_drag";
        this.pop_diy_info = sub.diy_info;
      }
    },
    to_pop_track_info(logistics_track_number) { 
      this.popName = "pop_track_info";
      this.track_number = logistics_track_number;
    },
    to_pop_email(row) { 
      this.popName = "pop_email";
      this.edit_row = row;
    },
    handleClickTab(e) {
      this.filter.page = 1;
      this.getStaticsOrders(false)
      this.getOrderOptions()
      this.getList(true);
    },
    click_exception(exception_status) { 
      this.filter.page = 1;
      this.filter.order_status ="0";
      this.filter.exception_status = exception_status;
      this.filter.notice_flag_status = 0;
      this.filter.has_seller_remark = 0;
      this.getStaticsOrders(false)
      this.getOrderOptions()
      this.getList(true);
    },
    click_notice_flag() { 
      this.filter.page = 1;
      this.filter.notice_flag_status = this.filter.notice_flag_status == 1 ? 0 : 1;
      this.filter.order_status ="0";
      this.filter.has_seller_remark = "0";
      this.filter.exception_status = "0";
      this.getStaticsOrders(false)
      this.getOrderOptions()
      this.getList(true);
    },
    click_has_seller_remark() { 
      this.filter.page = 1;
      this.filter.has_seller_remark = this.filter.has_seller_remark == 1 ? 0 : 1;
      this.filter.order_status ="0";
      this.filter.exception_status = "0";
      this.filter.notice_flag_status = "0";
      this.getStaticsOrders(false)
      this.getOrderOptions()
      this.getList(true);
    },
    change_country_filter() { 
      this.filter.page = 1;
      this.getList(true);
    },
    change_app_filter() {
      this.filter_page = 1;
      this.getList(true);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'success-row-222' //这是类名
      } else {
        return ''
      }
    },
    removeDiyFile(file, row) {
      this.$confirm('删除属性', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .post("/v1/pri/orders/remove-diy-create", {
            order_id: row.id,
            file_id: file.id
          })
          .then((response) => {
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList(false)
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
      })
    },
    getSystemSkuOptions() {
      this.$http
        .post("/v1/pri/goods-sku/get-options", { page: 1, size: 1000 })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.system_sku_options = res.data.list;
          }
        });
    },
    getOrderOptions() {
      this.$http.post("/v1/pri/orders/options", this.filter).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          this.country_options = res.data.country_options;
          this.app_options = res.data.app_options;
        }
      });
    },
    exportExcel() {
      this.$http.post("/orders/export/export", this.filter).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          window.location.href = res.data.file_oss;
        }
      });
    },
    pullShopifyOrders() {
      this.$store.commit("setLoading", { text: "正在获取最新订单.." });
      this.$http.post("/v1/pri/shopify-orders/pull-orders", this.filter).then((response) => {
        this.$store.commit("setLoading", false);
        var res = response.data;
        if (res.code == 1) {
          alert("同步成功，请刷新页面")
          this.search();
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    pullShopifyOrders_force(){
      this.$confirm('Sync Force ?' + this.filter.keyword, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在获取最新订单.." });
        this.$http.post("/v1/pri/shopify-orders/pull-orders-force", {app_id:this.filter.app_id,ebay_order_name:this.filter.keyword}).then((response) => {
          this.$store.commit("setLoading", false);
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: '同步成功',
              type: 'success'
            });
            this.getList()
          } else {
            this.$message({
                message: res.msg,
                type: 'warning'
            });
          }
        });
      }).catch(() => {});
    },
    upload_produce_images_success(res, file, fileList, row) {
      var produce_images = row.produce_images;
      if (null == produce_images) {
        produce_images = new Array();
      }
      produce_images.push({
        file_id: res.data.id,
        file_oss_ali: res.data.file_oss,
      })

      this.save_produce_image(row.id, produce_images);
    },
    remove_produce_images(row, remove_image_index) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var produce_images = row.produce_images;
        if (null == produce_images) {
          produce_images = new Array();
        }
        var arr = [];
        for (var i = 0; i < produce_images.length; i++) {
          if (i != remove_image_index) {
            arr.push(produce_images[i])
          }
        }
        this.save_produce_image(row.id, arr, true);
      }).catch(() => { });
    },
    save_produce_image(orders_goods_id, produce_images, is_delete_action) {
      this.$http
        .post("/v1/pri/orders/save-produce-images", {
          orders_goods_id: orders_goods_id,
          produce_images: produce_images,
          is_delete_action:is_delete_action ? 1 : 0,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getList(false)
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    change_produce_image_font_color(row, color_value) {
      this.$confirm('这会重做图案，确定修改文字颜色?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          row.produce_image_doing = true
          this.$http.post("/v1/pri/orders/change-produce-image-font-color", {orders_goods_id:row.id, color_value:color_value}).then((response) => {
            this.loading = false;
            var res = response.data;
            row.produce_image_doing = false;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList()
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },
    do_produce_image_clear(row, file_oss_ali) {
      this.$confirm('确认生成高清脸吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          row.produce_image_doing = true
          this.$http.post("/v1/pri/orders/clear-produce-images", {orders_goods_id:row.id, file_oss_ali:file_oss_ali}).then((response) => {
            this.loading = false;
            var res = response.data;
            row.produce_image_doing = false;
            if (res.code == 1) {
              this.$message({
                message: '生产成功了吗？确认一下！对比一下！',
                type: 'success'
              });
              this.getList()
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },
    remove_produce_image_clear(row, file_oss_ali_clear) {
      this.$confirm('你这个老六，你确认删除高清脸吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          row.produce_image_doing = true
          this.$http.post("/v1/pri/orders/remove-clear-produce-images", {orders_goods_id:row.id, file_oss_ali_clear:file_oss_ali_clear}).then((response) => {
            this.loading = false;
            var res = response.data;
            row.produce_image_doing = false;
            if (res.code == 1) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getList()
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },
    add_my_spec_line(row) {
      row.produce_specs.push({
        id:0,
        sku_title:"",
        quantity: "",
        sku_id:"",
        produce_model_id:"",
        produce_model_name: "",
        orders_goods_id: row.id,
        is_edit_mode:true,
      })
    },
    check_spec_option(spec) { 
      spec.is_edit_mode = true;
      if (spec.produce_model_id && spec.sku_id) {
        this.save_my_spec(spec);
      }
    },
    save_my_spec(spec) {
      this.$http.post("/v1/pri/orders/produce-spec-save", spec).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          spec.is_edit_mode = false
          this.$message({
            message: 'Save success',
            type: 'success'
          });
        } else {
          this.$message({
              message: res.msg,
              type: 'warning'
          });
        }
      }).catch((err) => { 
        alert(err)
      });
    },
    del_my_spec(row, index_spec) {
      this.$confirm('确定刪除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        var specs = row.produce_specs;
        if (specs.length <= 1) {
          this.$message({
            message: "Can not remove all specs",
            type: 'warning'
          });
          return;
        }
        var del = specs[index_spec];
        if (del.hasOwnProperty('id') && del.id) {
          this.$http.post("/v1/pri/orders/produce-spec-del", {orders_goods_id:row.id, id: del.id }).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              var tmp = [];
              for (var i = 0; i < specs.length; i++) { 
                if (i != index_spec) { 
                  tmp.push(specs[i]);
                }
              }
              row.produce_specs = tmp;
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          });
        } else { 
          var tmp = [];
          for (var i = 0; i < specs.length; i++) { 
            if (i != index_spec) { 
              tmp.push(specs[i]);
            }
          }
          row.produce_specs = tmp;
        }
      }).catch(() => { });
    },
    change_factory_phone_case_style(spec) {
      spec.is_edit_mode = true;
      if (!spec.factory_phone_case_style_id) {
        spec.factory_phone_case_style_id = 0;
      }
      this.$http.post("/v1/pri/factory-orders/save-order-style", spec).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          spec.is_edit_mode = false
          this.$message({
            message: 'Save success',
            type: 'success'
          });
        } else {
          this.$message({
              message: res.msg,
              type: 'warning'
          });
        }
      }).catch((err) => { 
        alert(err)
      });
    },
    notice_focus_click(row) {
      row.notice_flag_status = row.notice_flag_status == 1 ? 0 : 1;
      this.$http.post("/v1/pri/orders/notice-flag", {order_id:row.id, notice_flag_status:row.notice_flag_status}).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
    },
    
    to_pending_order(row) {
      this.$confirm('确定打回待处理?', '搁置', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/v1/pri/orders-step/pending", {order_no_list:[row.order_no]}).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList()
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },
    to_approve_order(order_no_arr) {
      this.$store.commit("setLoading", { text: "正在提交审核.." });
      this.$http.post("/v1/pri/orders-step/approve", {order_no_list:order_no_arr}).then((response) => {
          this.loading = false;
          this.$store.commit("setLoading", false);
          var res = response.data;
          if (res.code == 1) {
            this.$message({
                message: '操作成功',
                type: 'success'
            });
            this.getList()
          } else {
            this.$message({
                message: res.msg,
                type: 'warning'
            });
          }
        });
    },
    approve_page(){
      this.$confirm('确定审核本页所有NAME壳?', '审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var order_no_arr = [];
          for (var i =0; i<this.list_data.list.length; i++) {
            var flag = true;
            var subs = this.list_data.list[i].detail;
            for (var j =0; j <subs.length; j++) {
              var sub = subs[j];
              if (!sub.produce_images || sub.produce_images.length < 1) {
                flag = false;
                break;
              }
              var fontInput = "";
              if (sub.hasOwnProperty('customize_form') && sub.customize_form) {
                  if (sub.customize_form && sub.customize_form.hasOwnProperty('your_name') && sub.customize_form.your_name) {
                    fontInput = sub.customize_form.your_name;
                  }
              }
              var fontName = "";
              if (sub.hasOwnProperty('font_info') && sub.font_info) {
                if (sub.font_info.hasOwnProperty('font_name') && sub.font_info.font_name) {
                  fontName = sub.font_info.font_name;
                }
              }
              if ( !fontInput || !fontName) {
                flag = false;
                break;
              }
            }
            if (flag) {
              order_no_arr.push(this.list_data.list[i].order_no);
            }
          }
          this.to_approve_order(order_no_arr);
        }).catch(() => {});
    },
    to_produce_order(row) {
      this.$confirm('确定生产?', '生产', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/v1/pri/orders-step/produce", {order_no_list:[row.order_no]}).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList()
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },
    to_create_package(row) {
      this.edit_row = row;
      this.is_package_2 = false;
      this.is_produce_2 = false;
      this.popName = "pop_create_package";
    },
    to_create_package_2(row) {
      this.edit_row = row;
      this.is_package_2 = true;
      this.is_produce_2 = false;
      this.popName = "pop_create_package";
    },
    to_printf_order(row) {
      this.$http.post("/v1/pri/orders-step/printf", {order_no_list:[row.order_no]}).then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getList()
          } else {
            this.$message({
                message: res.msg,
                type: 'warning'
            });
          }
        });
    },
    print_one_label(package_row) { 
      this.$store.commit("setLoading", { text: "正在获取面单.." });
      this.$http
        .post("/v1/pri/logistics/label-pdf", {package_id:package_row.id})
        .then((response2) => {
          this.$store.commit("setLoading", false);
          var res = response2.data;
          if (res.code == 1) {
            this.$message({
              message: "获取成功",
              type: "success",
            });
            const link = document.createElement('a');
            link.href = res.data.file_pdf;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    to_send_order(package_row) {
      this.$confirm('确定发货?', '发货', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/v1/pri/orders-step/send-package", {package_id:package_row.id}).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList()
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },
    to_copy_track_link(package_row) { 
      var text = "https://www.17track.net/?nums=" + package_row.track_number;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
                message: '已复制链接：' + text,
                type: 'success'
              });
        }).catch(function(err) {
          this.$message({
                  message: '无法复制文本：' + err,
                  type: 'warning'
              });
        });
    },
    to_storage_order(row) {
      this.$confirm('确定搁置?', '搁置', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/v1/pri/orders-step/storage", {order_no_list:[row.order_no]}).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList()
            } else {
              this.$message({
                  message: res.msg,
                  type: 'warning'
              });
            }
          });
        }).catch(() => {});
    },
    getSystemModelOptions() {
      this.$http
        .post("/v1/pri/diy-model/lists", {
          status: 1,
          page: 1,
          size: 1000,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.systerm_model_options = res.data.list;
          }
        });
    },
    get_members_options() {
      this.$http
        .post("/v1/pri/cfg-members/options", {
          status: 1,
          page: 1,
          size: 1000,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.member_options = res.data;
          }
        });
    },
    getStaticsOrders(is_loading = true) {
      this.$http.post("/v1/pri/orders/statics", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          var statics = res.data.statics_orders;
          for (var i = 0; i < statics.length; i++) { 
            statics[i].status = statics[i].status + "";
          }
          this.statics_orders = statics;

          var exception_orders = res.data.exception_orders;
          for (var i = 0; i < exception_orders.length; i++) { 
            exception_orders[i].status = exception_orders[i].status + "";
          }
          this.exception_orders = exception_orders;
        }
      });
    },
    reload_row(order_no){
      this.$http.post("/v1/pri/orders/lists", {order_no:order_no, page:1, size:10}).then((response) => {
        this.loading_table = false;
        var res = response.data;
        if (res.code == 1) {
          var row = res.data.list[0];
          var list = this.list_data.list;
          for (var i=0; i<list.length; i++) {
            if (list[i].id == row.id) {
              list[i] = row;
              this.$set(this.list_data.list, i, row);
              break;
            }
          }
          this.list_data.list = list;
        }
      });
    },
    getList(is_loading = true, callback = null) {
      if (is_loading) {
        this.loading_table = true;
      }
      this.$http.post("/v1/pri/orders/lists", this.filter).then((response) => {
        this.loading_table = false;
        var res = response.data;
        if (res.code == 1) {
          this.list_data = res.data;
          this.getStaticsOrders();
          var order_ids =[];
          for (var i=0; i<res.data.list.length; i++) {
            order_ids.push(res.data.list[i].id);
          }
          this.getRemarks(order_ids);
          if (callback) {
            callback(res.data.list);
          }
        }
      });
    },
    blur_seller_remark(row){
      if (!row.seller_remark2) {
        row.remark_input_rows = 3;
      }
    },
    saveRemark(row) {
      if (row.is_seller_remark_submit_loading) {
        return;
      }
      row.is_seller_remark_submit_loading = true;
      this.$http.post("/v1/pri/orders/save-remark", {id:row.id, content:row.seller_remark2}).then((response) => {
        var res = response.data;
        row.is_seller_remark_submit_loading = false;
        if (res.code == 1) {
          this.$message({
            message: "备注成功",
            type: "success",
          });
          row.seller_remark2 = "";
          row.remark_input_rows = 3;
          this.getRemarks([row.id])
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },  
    getRemarks(order_ids) {
      this.$http.post("/v1/pri/orders/remark-list", {order_ids:order_ids}).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          var remarks = res.data.list;
          var orders = this.list_data.list;
          for (var i=0; i<orders.length; i++) {
            var _remark_list = [];
            var _remark_list_slide = [];
            for (var j=0; j<remarks.length; j++) {
              if (orders[i].id == remarks[j].order_id) {
                _remark_list.push(remarks[j]);
                if ( _remark_list_slide.length < 2 ) {
                  _remark_list_slide.push(remarks[j]);
                }
              }
            }
            if ( _remark_list.length > 0 ) {
              orders[i].remark_list = _remark_list;
              orders[i].remark_list_slide = _remark_list_slide;
            }
          }
          this.list_data.list = orders;
        }
      });
    },  
    get_phone_case_style_options(){
      this.$http
        .post("/v1/pri/factory-style/options", {})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.phone_case_style_options = res.data;
          }
        });        
    },
    get_phone_model_options(){
      this.$http
        .post("/v1/pri/diy-model/options", {})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.phone_model_options = res.data.list;
          }
        });        
    },
    run_draw() {
      this.$confirm('不会覆盖已做的生产图', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const order_list = this.list_data.list;
        for (let i = 0; i < order_list.length; i++) {
          try {
            const subs = order_list[i].detail;
            for (let j = 0; j < subs.length; j++) {
              const drawRef = this.$refs.drawRef;
              if (subs[j].produce_images && subs[j].produce_images.length > 0) {
                continue;
              }
              await drawRef.run_canvas(order_list[i].ebay_order_name, subs[j], j); 
            }
          } catch (err) {
            console.log(err)
          }
        }
        console.log('所有任务已完成，正在刷新列表...');
        this.getList();
        this.$message.success('全部处理完毕');

      }).catch(() => {
        // 处理取消操作
      });
    },
  },
  mounted() {
    this.getOrderOptions();
    this.getStaticsOrders();
    this.getSystemModelOptions();
    this.getSystemSkuOptions();
    this.get_phone_case_style_options();
    this.get_phone_model_options();
    this.get_members_options();
    this.getList();
    var status = this.getUrlParam('status')
    if ( status == 6 ) {
      this.left_active = "paied"
    } else if ( status == 8 ) {
      this.left_active = "express"
    } else if ( status == 11 ) {
      this.left_active = "refund"
    }

    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }
    
    // var if_run_draw = this.getUrlParam('draw');
    // if ( if_run_draw ) {
    //   this.run_draw();
    // }

  },
};
</script>
<style>
.success-row-222 {
 
}

.warning-btns-dd2 .el-button--medium{padding: 10px 10px !important;}

.orders-page .sku-first-1{vertical-align: top;}


.package-list-li p.p2{border-top:1px dashed #afafaf;padding-top:5px;margin-top:5px;}
.package-list-li:last-child p.p2{border-bottom:1px dashed #afafaf;padding-bottom: 5px;}

.seller-remark-list-001{border-bottom: 1px dashed gray;padding-bottom: 5px;margin-bottom: 5px;}
.seller-remark-list-001:last-child{border-bottom: none;}

</style>


// WEBPACK FOOTER //
// src/pages/orders/Index.vue